export default __webpack_public_path__ + "static/media/money-back@2x.f14d90fb.png";